import messages from './perfil-list-translations';
import * as $ from 'jquery';
import Paginate from 'vuejs-paginate';
import { PerfilService } from '../../services/perfilService';
import { ApplicationConfig } from '../../../shared/applicationConfig';
import { ApplicationConstants } from '../../../shared/applicationConstants';
import { SharedService } from '../../../shared/services/sharedService';
import { AuthService } from '../../../login/services/authService.js';

export default {
    name: 'instamapsPerfilList',
    i18n: {
        messages,
    },
    data: () => {
        return {
            uid: '',
            isLoading: false,
            availableMaps: 0,
            minCharsToFilterText: ApplicationConfig.minCharsToFilterText,
            results: [],
            newestElement: undefined,
            searchInput: '',
            selectedPage: 1,
            selectedSortConcept: PerfilService.defaultGallerySortConcept,
            paginating: false,
            sorting: false,
            newMapUrl: ApplicationConstants.newMapUrl,
            fallbackImage: ApplicationConstants.fallbackImageUrl,
            baseImage: ApplicationConstants.baseImageUrl,
            perfilApps: [],
            appsConfigurades: [],
            pageElements: {
                numPages: 1,
                currentPage: 1,
                elements: [],
                currentSortConcept: PerfilService.defaultGallerySortConcept,
                currentOrder: ApplicationConfig.defaultSortOrder,
            },
            totalMapesDerivats: 0,
            totalMapesHeretats: 0,
        };
    },
    components: {
        paginate: Paginate,
    },
    props: {
        selectedLang: { type: String },
        mapaBorrar: { type: String},
        appBorrar: { type: String},
        mapaVisibilitat: { type: String},
        refresh: { type: Boolean},
        user: { type: Object },
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
        truncate: (value, length) => SharedService.truncateText(value, length),
    },
    computed: {
        galleryItems: function () {
            this.pageElements = PerfilService.getElements(this.results, this.selectedPage, this.searchInput, this.pageElements.currentSortConcept, this.pageElements.currentOrder, this.selectedSortConcept, this.paginating, this.sorting);
            this.paginating = false;
            this.sorting = false;
            return this.pageElements.elements;
        },
        galleryApps: function(){
            return this.perfilApps.concat(this.appsConfigurades);
        }
    },
    watch: {
        'results': function () {
            this.loaded();
        },
        'mapaBorrar': function(){
           if('' !== this.mapaBorrar){
            this.results = this.results.filter((item) => {
                return item.businessId !== this.mapaBorrar;
            });
            this.availableMaps = this.results.length;
           }
        },
        'appBorrar': function(){
            if('' !== this.appBorrar){
             this.appsConfigurades = this.appsConfigurades.filter((item) => {
                 return item.businessId !== this.appBorrar;
             });
            }
         },
        'mapaVisibilitat': function(){
            if('' !== this.mapaVisibilitat){
             this.results = this.results.map((item) => {
                var mapaBusinessId = this.mapaVisibilitat.substring(0, this.mapaVisibilitat.indexOf("_"));
                if (item.businessId === mapaBusinessId){
                    if(item.visibilitat === 'O'){
                        item.visibilitat = 'P';
                    }else{
                        item.visibilitat = 'O';
                    }
                }
                return item;
             });
            }
         },
        'refresh': function(){
            if(this.refresh){
                this.loadMaps();
            }
        },
        'user': function(){
            this.loadAllApps();
        }
    },
    methods: {
        loadAllApps(){
            if(this.user.tipusEntitatId && this.user.tipusEntitatId !== 1){
                this.loadApps();
                this.loadConfigurades(); 
            }
        },
        scrollToTop() {
            setTimeout(function () {
                $('#scroller').animate({
                    scrollTop: 0,
                }, 1000);
            }, 500);
        },
        clickCallback(pageNum) {
            this.selectedPage = pageNum;
            this.paginating = true;
            this.scrollToTop();
        },
        sortBy(concept) {
            this.loading();
            this.selectedSortConcept = concept;
            this.sorting = true;
            this.scrollToTop();
            const self = this;
            setTimeout(function () {
                self.loaded();
            }, 2000);
        },
        initialize() {
            this.selectedSortConcept = PerfilService.defaultGallerySortConcept;
            this.pageElements.currentSortConcept = PerfilService.defaultGallerySortConcept;
            this.currentOrder = ApplicationConfig.defaultSortOrder;
        },
        loading: function () {
            this.isLoading = true;
            this.$emit('loading');
        },
        loaded: function () {
            this.isLoading = false;
            this.$emit('loaded', { availableMaps: this.results.length, lastActivity: this.newestElement.dataPublicacio });
        },
        borrarMapa(mapa){
            this.$emit('borrarMapa', {mapa: mapa});
        },
        borrarApp(mapa){
            this.$emit('borrarApp', {mapa: mapa});
        },
        duplicarMapa(mapa){
            this.$emit('duplicarMapa', {mapa: mapa});
        },
        compartirMapa(mapa){
            this.$emit('compartirMapa', {mapa: mapa});
        },
        colaborarMapa(mapa){
            this.$emit('colaborarMapa', {mapa: mapa});
        },
        borrarColaboradorMapa(mapa){
            this.$emit('borrarColaboradorMapa', {mapa: mapa,socPropietari: this.socPropietari });
        },
        canviarVisibilitatMapa(mapa){
            this.$emit('canviarVisibilitatMapa', {mapa: mapa});
        },
        crearUsuarisMapa(mapa){
            this.$emit('crearUsuarisMapa', {mapa: mapa});
        },
        loadMaps: function(){
            this.loading();
            this.initialize();
            PerfilService.getAllElements().then((elements) => {
				if(elements.body.status === "ERROR") {
                    this.isLoading = false;
					this.$emit('logout');
				} else {
					this.results = elements.body.results;
					this.availableMaps = this.results.length;
					this.newestElement = SharedService.newestElement(elements);
					
				}
            });
        },
        loadApps: function(){
            let token = AuthService.getToken();
            let uid = AuthService.getUid();
            this.uid = uid;
			let apps = PerfilService.getAllApps(this.user.tipusEntitatId);
			if(apps) {
				apps = apps.map((item) => {
					item.url = item.url + uid + "&token=" + token;
					return item;
				});
				this.perfilApps = apps;
			}
        },
        loadConfigurades: function(){
            PerfilService.getUserApps().then((elements) => {
                if (elements === null){
                    this.appsConfigurades = [];
                }else{
                    let geolocalApps = elements.filter((item) => {
                        return (item.tipusAplicacio.abbr === 'par' || item.tipusAplicacio.abbr === 'atl'); 
                    }).map((item) => {
                        let app = {
                            nom: item.nomAplicacio,
                            url: ApplicationConstants.baseGeolocalUrl + item.tipusAplicacio.url + "visorId=" + item.businessId,
                            img: "/static/img/generic_thumb_"+item.tipusAplicacio.icon+".png",
                            businessId: item.businessId
                        };
                        if(ApplicationConstants.paramAplications[item.tipusAplicacio.action].eliminar){
                            app.eliminar = ApplicationConstants.paramAplications[item.tipusAplicacio.action].eliminar;
                        }
                        return app;
                    });
                    this.appsConfigurades = geolocalApps;
                } 
            });
        },
		newURLVisor: function(url, tipusEntitat) {
			var start = url.indexOf("/visor.html");
			const newURL = url.substring(start) + (tipusEntitat === 11 ? "?appmodul=sostenibilitat" : "");
			return newURL;
		},
		newURLEditor: function(url, socPropietari) {
            var start = url.indexOf("/mapa.html");
            var urlEditor = url.substring(start);
            if (!socPropietari) { urlEditor += "&mapacolaboratiu=si";}
			return urlEditor;
        },
        socPropietari: function(item){
            let uid = AuthService.getUid();
            return (item.entitatUid === uid) ? true : false; 
        },
        noesMapaDerivat: function(item){
            if (item.isMapaDerivat!==undefined && item.isMapaDerivat==="true") return false;
            else return true;
        },
        countMapesDerivats: function(){
            PerfilService.countMapesDerivats().then((elements) => {
                this.totalMapesDerivats = elements.body.results;
			});
        },
        countMapesHeretats: function(){
            PerfilService.countMapesHeretats().then((elements) => {
                this.totalMapesHeretats = elements.body.results;
			});
        },
        filterMapsDerivats: function() {
            this.loading();
            this.initialize();
            PerfilService.getMapesDerivats().then((elements) => {
				if(elements.body.status === "ERROR") {
                    this.isLoading = false;
					this.$emit('logout');
				} else {
					this.results = elements.body.results;
					this.availableMaps = this.results.length;
					this.newestElement = SharedService.newestElement(elements);
					
				}
            });
        },
        filterMapsHeretats: function(){
            this.loading();
            this.initialize();
            PerfilService.getMapesHeretats().then((elements) => {
				if(elements.body.status === "ERROR") {
                    this.isLoading = false;
					this.$emit('logout');
				} else {
					this.results = elements.body.results;
					this.availableMaps = this.results.length;
					this.newestElement = SharedService.newestElement(elements);
					
				}
            });
        },
        noesMapaHeretat: function(item){
            if (item.isMapaHeretat!==undefined && item.isMapaHeretat==="true") return false;
            else return true;
        }
    },
    mounted() {
        $('.search-sort-toggle').on('click', () => {
            ($('.search-sort').css('display') === 'none') ? $('.search-sort').css('display', 'block'): $('.search-sort').css('display', 'none');
        });
        this.loadMaps();
        this.loadAllApps();
        this.countMapesDerivats();
        this.countMapesHeretats();
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/perfil-list/perfil-list.js